import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { filter, map, take } from 'rxjs/operators';
import { getMessaging, getToken, onMessage } from "@angular/fire/messaging";
import { environment } from 'src/environments/environment';
import { Platform } from '@angular/cdk/platform';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ActivatedRoute, ChildrenOutletContexts, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from "@angular/router";
import { VersionService } from './core/services/version.service';
//import { TawkMessengerAngular } from '@tawk/tawk-messenger-angular';
import { APP_VERSION } from '../environments/version';
import { SafeStorage } from './core/utils/safe-storage';

// import {
//   ActionPerformed,
//   PushNotificationSchema,
//   PushNotifications,
//   Token,
// } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { Location } from '@angular/common';
import { DataService } from './core/services/data.service';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  stagger
} from '@angular/animations';
import { AuthService } from './core/services/auth.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { HttpClient } from '@angular/common/http';
import { PaymentService } from './core/services/payment.service';
import { SessionService } from './core/services/session.service';
import { MatDialog } from '@angular/material/dialog';
import { ThemeService } from './core/services/theme.service';
import { AnalyticsService } from './core/services/analytics.service';
import { UploadBannerService } from './core/services/upload-banner.service';
import { isUploadLive, reloadApp } from './core/utils/reload-app';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

declare let gtag: (...args: any[]) => void;
declare var LemonSqueezy: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    // Define an animation trigger named 'pageLoadAnimation'
    trigger('pageLoadAnimation', [
      // Define a transition for when elements enter the DOM (:enter is shorthand for void => *)
      transition(':enter', [
        // Query for all elements with the class 'animated-item' within the trigger's host
        query('.animated-item', [
          // Set initial styles for the elements:
          // - fully invisible (opacity: 0)
          // - significantly moved down (translateY: 50px)
          // - rotated along the X-axis (rotateX: -90deg) for a 'flip-in' effect
          // - set transform-origin to top for the rotation to pivot from the top
          style({ opacity: 0, transform: 'translateY(50px) rotateX(-90deg)', 'transform-origin': 'top' }),
          // Stagger the animation for each 'animated-item' by 150ms (increased for more distinct sequence)
          stagger(150, [
            // Animate to the final state:
            // - fully visible (opacity: 1)
            // - original position (translateY: 0)
            // - no rotation (rotateX: 0deg)
            // - duration increased to 700ms for a more noticeable effect, using ease-out
            animate('700ms ease-out', style({ opacity: 1, transform: 'translateY(0) rotateX(0deg)' }))
          ])
        ], { optional: true }) // optional: true prevents errors if no .animated-item elements are found
      ])
    ])
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  version!: string;
  updateAvailable: boolean = false;
  title = 'picaggo';
  isOnline: boolean;
  modalVersion: boolean = false;
  // Hybrid update UX: a subtle toast the user can tap to update immediately; if
  // ignored, the app auto-reloads on the next route navigation (see onUpdateDetected).
  showUpdateToast: boolean = false;
  // The toast is only ever shown on /home. An update detected elsewhere waits
  // here until the user lands on home, so its 8s auto-hide isn't spent off-screen.
  private updateToastPending = false;
  /** True while /home is showing — the only route the update toast appears on. */
  onHomePage = false;
  private updateArmed = false;   // guards against re-handling the same update repeatedly
  private pendingReload = false; // when true, next navigation triggers a seamless reload
  private updateHeldReported = false; // one 'held' event per armed update, not one per navigation
  modalPwaEvent: any;
  modalPwaPlatform: string | undefined;
  modalPwaPlatform1: string | undefined;

  /**
   * The "Only in the Picaggo App" install banner is position:fixed at bottom:0,
   * so it reserves no scroll space and covers the last ~80px of whatever route
   * is showing — on a locked album that is the "Uploads are disabled" notice.
   * Drives both the banner and the flow-level spacer that offsets it.
   */
  get showAppInstallBanner(): boolean {
    // Never on a shared flipbook. That page is opened by someone who followed a
    // link to look at photos, on their first ever visit — exactly the profile
    // this banner targets, and exactly the person it would be covering the book
    // for. The page carries its own "Make your own with Picaggo" call to
    // action, which is better aimed than a generic install prompt.
    if (this.onPublicSharePage) return false;
    // Never on the deferred-login landing page either. The banner is fixed at
    // bottom:0 with z-index 999999999, so it covers both the Create button and
    // the sign-in sheet that button opens — i.e. it would sit on top of the one
    // conversion this page exists to produce.
    if (this.onDeferredStart) return false;
    return this.modalPwaPlatform1 === 'ANDROID' || this.modalPwaPlatform1 === 'IOS';
  }

  /** True while a public, no-session route is showing. See hideTopBarRoutes. */
  onPublicSharePage = false;
  /** True while the deferred-login landing page is showing. */
  onDeferredStart = false;
  /** environment.features.persistentUploadBanner — off in prod. */
  readonly uploadBannerEnabled = environment.features.persistentUploadBanner === true;
  private logs: string[] = [];
  message: any = null;
  //timeout changes
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date | null | undefined = null;
  showTopBar: boolean = true;
  currentUrl: string = '';
  //add to component constructor: , private logService: LogToS3Service
  constructor(
    private router: Router,
    private afAuth: AngularFireAuth,
    public authService: AuthService,
    private route: ActivatedRoute,
    private sessionService: SessionService,
    private platform: Platform,
    private contexts: ChildrenOutletContexts,
    public location: Location, private http: HttpClient,
    public dataService: DataService,
    private paymentService: PaymentService,
    private versionService: VersionService,
    private dialog: MatDialog,
    private themeService: ThemeService,
    private analytics: AnalyticsService,
    private uploadBanner: UploadBannerService
    //   public TawkMessengerAngular: TawkMessengerAngular
  ) {
    this.version = this.versionService.version;
    this.isOnline = false;
    this.modalVersion = false;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        // Hide top bar only for specific routes, show it everywhere else
        const hideTopBarRoutes = [
          'open-event-invite',
          'welcome-screen',
          'open-rsvp-response',
          'open-event-detail',
          'guest',
          'live',
          'auth/login',
          // The deferred-login landing page is a login page and carries its own
          // chrome. Safe to list here — unlike a public route — because
          // StartComponent clears the persisted `showTopBar` on the way out,
          // exactly as LoginComponent does.
          'auth/start',
          //'slideshow'
        ];

        const shouldHide = hideTopBarRoutes.some(route => event.url.includes(route)) ||
                          event.url.includes('?token=');

        // Deliberately NOT in hideTopBarRoutes above. That path writes through
        // DataService.showTopBar, which persists to localStorage, and the
        // `forceHide` read below then keeps the bar hidden on every later route
        // — so a visitor who opened a shared flipbook and then tapped "Make
        // your own" would land on a home screen with no top bar. The share page
        // covers the chrome with its own full-screen layer instead.
        this.onPublicSharePage = event.url.includes('/flipbook/');
        this.onDeferredStart = event.url.includes('auth/start');
        this.onHomePage = (event.urlAfterRedirects || event.url).split(/[?#]/)[0] === '/home';
        this.maybeShowUpdateToast();

        // Respect an explicit 'false' stored in localStorage (e.g. demo-direct-gallery)
        const forceHide = SafeStorage.getItem('showTopBar') === 'false';

        this.dataService.showTopBar = !shouldHide && !forceHide;
      });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.closeAll();
      }
    });

    // Tear down the index.html splash the moment a real screen exists. Waiting for
    // NavigationEnd (and one frame after it, so the component has actually been
    // painted) is what closes the gap: hiding it at bootstrap would expose the
    // white page again while the first lazy route chunk downloads.
    // NavigationError/Cancel are included so a failed first navigation cannot
    // strand the user on the splash.
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd ||
                          event instanceof NavigationError ||
                          event instanceof NavigationCancel),
        take(1)
      )
      .subscribe(() => {
        requestAnimationFrame(() => this.hideSplash());
      });

    // Seamless update: once an update is pending, apply it on the user's next route
    // navigation — a natural, non-disruptive moment (they've left the previous screen).
    // Never reload over an upload. An open dialog is not the test: a minimized batch
    // keeps running with no dialog at all, which is exactly when this used to reload.
    // The update stays armed and applies on a later navigation once the upload ends.
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.pendingReload && this.dialog.openDialogs.length === 0) {
          if (isUploadLive()) {
            // Silent before: a held update looked exactly like no update.
            if (!this.updateHeldReported) {
              this.updateHeldReported = true;
              this.analytics.capture('app_reload_deferred', { reason: 'app_update', trigger: 'navigation' });
            }
            return;
          }
          this.pendingReload = false;
          this.updateToastPending = false;
          this.showUpdateToast = false;
          this.activateUpdateAndReload();
        }
      });

    // Re-check the minimized-upload snapshot on every navigation. The snapshot
    // is written by a dialog that is destroyed on close, so nothing else would
    // tell the banner to appear once the user has moved on — which is the one
    // case the banner exists for. No-ops when the feature flag is off.
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.uploadBanner.refresh());
  }

  /** Removes the index.html pre-bootstrap splash. Safe to call more than once. */
  private hideSplash(): void {
    const hide = (window as any).__picaggoHideSplash;
    if (typeof hide === 'function') {
      hide();
    }
  }

  // Called whenever a newer version is detected (SW message, controllerchange, or the
  // version.json poll). Arms a seamless auto-reload for the next navigation and shows a
  // subtle, tappable toast for users who'd rather update right away.
  private onUpdateDetected(): void {
    if (this.updateArmed) return; // handle each update once — stops the old nagging loop
    this.updateArmed = true;
    this.updateAvailable = true;
    this.updateToastPending = true;

    // Loop guard: if we already force-reloaded for an update this session and the version
    // STILL mismatches (a deploy inconsistency), don't auto-reload again — that would spin
    // in a refresh loop. Leave the toast so the user can retry manually if they want.
    // An in-memory sessionStorage (index.html's fallback for blocked storage) forgets
    // the guard on reload, so it could never stop the loop: never auto-reload there.
    const guardCannotPersist = !!(window as any).__picaggoMemoryStorage?.includes('sessionStorage');
    const alreadyReloaded = guardCannotPersist || sessionStorage.getItem('pendingUpdateReload') === '1';
    this.pendingReload = !alreadyReloaded;

    this.maybeShowUpdateToast();
  }

  /** Shows a pending update toast, but only on /home. */
  private maybeShowUpdateToast(): void {
    if (!this.updateToastPending || !this.onHomePage) return;
    this.updateToastPending = false;
    this.showUpdateToast = true;
    // Auto-hide the toast after a few seconds; the pending reload stays armed regardless.
    setTimeout(() => { this.showUpdateToast = false; }, 8000);
  }

  initLemon() {
    if (window && (window as any).LemonSqueezy) {
      (window as any).LemonSqueezy.Setup({
        eventHandler: (event: any) => {
          if (event.event === 'Checkout.Success') {
            // console.log('Payment successful', event.data); //__CONSOLE_LOG__
          }
          if (event.event === 'Checkout.Closed') {
            // console.log('Checkout closed'); //__CONSOLE_LOG__
          }
        }
      });
    }
  }
  // getRouteAnimationData() {
  //   return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  // }

  /**
   * PostHog pageview for a hash-routed SPA.
   *
   * The app runs with `useHash: true`, so the real route sits after the `#` —
   * which posthog-js (and every other analytics tool) ignores when deriving
   * `$pathname`. That is why 30 days of pageviews all recorded `$pathname = '/'`
   * despite people demonstrably being on invite, gallery and event screens.
   *
   * Automatic capture is disabled in AnalyticsService; this sends the route
   * explicitly instead, in three forms:
   *   - `$current_url` rewritten so the route sits in the path position, which
   *     makes PostHog derive `$pathname` natively and keeps its built-in path
   *     features working.
   *   - `route_pattern` — the same value under our own key, so analysis does not
   *     depend on how posthog-js treats a supplied `$current_url`.
   *   - `raw_url` — the genuine address, hash intact, when the specific record
   *     matters rather than the shape.
   */
  /** Last pattern captured — several components independently redirect to
   * the same route (e.g. /auth/login) while auth state settles, each
   * producing its own NavigationEnd. Without this guard that churns out
   * 3-4 identical pageviews in a few seconds and pollutes every funnel. */
  private lastCapturedPattern: string | null = null;

  private capturePageview(urlAfterRedirects: string): void {
    const pattern = this.routePattern();
    if (pattern === this.lastCapturedPattern) return;
    this.lastCapturedPattern = pattern;

    // Leaving an event clears its context, so a later unrelated event — a
    // pricing page view, say — never claims to belong to whatever event was
    // open last. Clearing matters as much as setting: stale context is worse
    // than none, because it looks correct.
    if (this.LEAVES_EVENT_CONTEXT.some(p => pattern.startsWith(p))) {
      this.analytics.clearEventContext();
    }

    this.analytics.capture('$pageview', {
      $current_url: window.location.origin + pattern,
      route_pattern: pattern,
      raw_url: window.location.href,
      resolved_url: urlAfterRedirects,
    });
  }

  /** Routes that mean the user is no longer inside a specific event. */
  private readonly LEAVES_EVENT_CONTEXT = [
    '/home',
    '/myevents',
    '/auth',
    '/pricing',
    '/my-account',
    '/purchase-history',
  ];

  /**
   * Walks the activated route tree and rebuilds the declared path, so
   * /gallery/5f9059d8 reports as /gallery/:id. Without this every event id
   * becomes its own row and "how many people opened a gallery" is unanswerable.
   */
  private routePattern(): string {
    let route = this.route.root;
    const parts: string[] = [];
    while (route.firstChild) {
      route = route.firstChild;
      const path = route.routeConfig?.path;
      if (path) parts.push(path);
    }
    return '/' + parts.join('/');
  }

  async ngOnInit(): Promise<void> {
    this.themeService.init();
    this.initLemon();

    //analytics
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      gtag('config', 'G-WPJTRTCZBK', {
        page_path: event.urlAfterRedirects
      });
      this.capturePageview(event.urlAfterRedirects);
    });

    // Handle navigation errors: reload on stale chunk, redirect to home otherwise
    this.router.events.pipe(
      filter(event => event instanceof NavigationError)
    ).subscribe((event: any) => {
      const isChunkError = event.error?.name === 'ChunkLoadError' ||
        (event.error?.message && event.error.message.includes('Loading chunk'));
      if (isChunkError) {
        reloadApp('chunk_load_error');
      } else {
        this.router.navigate(['/home']);
      }
    });
    //

    // console.log('App Version:', environment.version); //__CONSOLE_LOG__
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === 'NEW_VERSION') {
          this.onUpdateDetected();
        }
      });
      // custom-sw.js (Workbox) calls skipWaiting()/clientsClaim() on its own, so a new
      // worker activates without our involvement. Catch that activation so we can update
      // seamlessly — otherwise tabs left open keep running the old app shell.
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        this.onUpdateDetected();
      });
    }
    // setTimeout(() => { this.loadModalPwa() }, 6000);
    this.currentUrl = new URL(window.location.href).toString();//this.router.url; // Get the current URL
    // console.log(this.currentUrl); //__CONSOLE_LOG__
    
    // Initialize top bar visibility - default to true (shown)
    try {
      const storedTopBar = SafeStorage.getItem('showTopBar');
      if (storedTopBar !== null) {
        this.dataService.showTopBar = storedTopBar === 'true';
      } else {
        // Default to showing top bar
        this.dataService.showTopBar = true;
      }
    } catch {
      this.dataService.showTopBar = true;
    }


    this.updateOnlineStatus();

    window.addEventListener('online', this.updateOnlineStatus.bind(this));
    window.addEventListener('offline', this.updateOnlineStatus.bind(this));
    this.checkForUpdate();
    // if (this.swUpdate.isEnabled) {
    //   const isNewVersion = await this.swUpdate.checkForUpdate();
    //   // Check if the new version is available
    //   if (isNewVersion) {
    //     const isNewVersionActivated = await this.swUpdate.activateUpdate();
    //     // Check if the new version is activated and reload the app if it is
    //     if (isNewVersionActivated) {
    //       this.updateAvailable = true;
    //       //window.location.reload();
    //       console.log(this.updateAvailable);
    //     }
    //     //resolve(true);
    //   }
    //   // if(this.currentUrl.includes('login'))
    //   //   {
    //   //     this.showTopBar = false;
    //   //   }
    //   //   else{
    //   //     this.showTopBar = true;
    //   //   }
    //   //   this.showTopBar = this.dataService.showTopBar;
    //   //resolve(true);
    // }

    // When user closes the tab/PWA
    window.addEventListener('beforeunload', () => {
      this.sessionService.endSession();
    });

    // Warm up Lambda functions immediately so cold-start delay is gone
    // by the time the user reaches any event page. Fire-and-forget.
    setTimeout(() => this.warmUpLambdas(), 0);
  }

  private warmUpLambdas(): void {
    const DEMO_HEX = '5f9059d8';
    const urls = [
      `https://n7lrsuh3vi.execute-api.us-west-1.amazonaws.com/pwa_get_media_count?hex=${DEMO_HEX}`,
      // pwa_fetch_media backs getEventById(), the call event-detail's cover image (its
      // LCP element) waits on. Any user - host or guest - can land there straight from
      // a link/QR code, not just after Home, so warm it unconditionally here too.
      `https://5u4005m3pg.execute-api.us-west-1.amazonaws.com/pwa_fetch_media?hex=${DEMO_HEX}`,
    ];

    // A guest opening an invite link, or already inside the event they joined. The
    // isGuestUser flag is not set yet on that first open, so the route has to say it.
    // Guests only use the two calls above (event-detail's gallery). The demo
    // gallery and Home's calls were firing for them anyway: the demo call returns
    // 400 and holds the line for up to 7 s on a first load, and a `user` key left
    // over from an earlier visit made the guest look signed in, so Home's calls
    // went out too (401).
    const hash = window.location.hash || '';
    const isGuest = localStorage.getItem('isGuestUser') === 'true' ||
      hash.startsWith('#/guest/') || hash.startsWith('#/live/');
    if (isGuest) {
      urls.forEach(url => this.http.get(url).subscribe({ error: () => {} }));
      return;
    }

    // pwa-fetch-gallery-without-login is for demo sessions and signed-out visitors
    // only — never warm it up for an actual logged-in user.
    const isGuestOrDemo = localStorage.getItem('isDemoUser') === 'true';
    const isLoggedIn = !!localStorage.getItem('user') && localStorage.getItem('user') !== 'null' && !isGuestOrDemo;
    if (!isLoggedIn) {
      urls.push(`https://78n1ciwz29.execute-api.us-west-1.amazonaws.com/dev/pwa-fetch-gallery-without-login?hex=${DEMO_HEX}`);
    } else {
      // Logged-in users land on the Home route right after this fires, and Home's
      // first render blocks on exactly these two Lambdas (getTotalCategory +
      // getHomePageData). Warming them here means their cold start overlaps with
      // Angular bootstrap instead of stacking after it. The auth header is
      // intentionally omitted — we only need the Lambda container to spin up,
      // not a real response, so a 401 here is fine and ignored below.
      urls.push('https://02l1hwixc6.execute-api.us-west-1.amazonaws.com/pwa_get_total_categories');
      urls.push('https://yvmxlr61n9.execute-api.us-west-1.amazonaws.com/pwa_get_home_page_data');
    }

    urls.forEach(url => this.http.get(url).subscribe({ error: () => {} }));
  }
  checkForUpdate() {
    this.http.get<{ version: string }>('/assets/version.json', {
      params: { t: Date.now().toString() } // prevent caching
    }).subscribe({
      next: latest => {
        // console.log('Latest:', latest.version, 'Current:', APP_VERSION); //__CONSOLE_LOG__
        if (latest.version !== APP_VERSION) {
          this.onUpdateDetected();

          // version.json being stale means custom-sw.js changed too (update-version.js
          // stamps both together). Force the browser to re-fetch the SW script now
          // instead of waiting on its own throttled background check, so a waiting
          // worker actually exists by the time we apply the update.
          if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistration().then(reg => reg?.update());
          }
        } else {
          // Versions match — clear the loop guard so a genuine future update can auto-reload.
          sessionStorage.removeItem('pendingUpdateReload');
        }
      },
      // A momentary network drop just means we'll check again next poll — not actionable.
      error: () => {},
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('online', this.updateOnlineStatus.bind(this));
    window.removeEventListener('offline', this.updateOnlineStatus.bind(this));
  }

  updateApp(): void {
    this.activateUpdateAndReload();
  }

  public updateVersion(): void {
    // User tapped "Update now" on the toast — apply immediately.
    this.modalVersion = false;
    this.updateToastPending = false;
    this.showUpdateToast = false;
    this.pendingReload = false;
    this.activateUpdateAndReload();
  }

  private activateUpdateAndReload(): void {
    // An explicit "Update now" lands here too. Hold it rather than end an upload;
    // the navigation handler applies it once nothing is uploading.
    if (isUploadLive()) {
      this.pendingReload = true;
      if (!this.updateHeldReported) {
        this.updateHeldReported = true;
        this.analytics.capture('app_reload_deferred', { reason: 'app_update', trigger: 'update_now' });
      }
      return;
    }
    this.updateHeldReported = false;

    // Mark that we're force-reloading for an update this session, so onUpdateDetected's
    // loop guard can prevent an infinite refresh if the version still mismatches after.
    try { sessionStorage.setItem('pendingUpdateReload', '1'); } catch { }

    // We run a hand-rolled Workbox SW (custom-sw.js), not Angular's ngsw-worker.
    // The new worker calls skipWaiting()/clientsClaim() on its own, but control of
    // THIS tab only transfers once 'controllerchange' fires — that's async. If we
    // reload before it fires, the navigation request can still be intercepted by the
    // OLD worker's cached index.html, re-bootstrapping the old version forever.
    const clearCachesAndReload = () => {
      if (typeof caches !== 'undefined') {
        caches.keys()
          .then(names => Promise.all(names.map(name => caches.delete(name))))
          .catch(() => {})
          .then(() => reloadApp('app_update', { force: true }));
      } else {
        reloadApp('app_update', { force: true });
      }
    };

    if ('serviceWorker' in navigator) {
      const reg = navigator.serviceWorker;
      let reloaded = false;
      const onControllerChange = () => {
        if (reloaded) return;
        reloaded = true;
        reg.removeEventListener('controllerchange', onControllerChange);
        clearCachesAndReload();
      };

      if (reg.controller) {
        reg.controller.postMessage({ type: 'CLEAR_CACHE' });
      }
      reg.addEventListener('controllerchange', onControllerChange);

      // Nudge the waiting worker to activate immediately instead of waiting for
      // all old-version tabs to close.
      reg.getRegistration().then(registration => {
        registration?.waiting?.postMessage({ type: 'NEW_VERSION' });
      });

      // Safety net: some browsers never fire controllerchange if there's nothing
      // new to control (e.g. user already on latest). Don't hang forever.
      setTimeout(onControllerChange, 2000);
    } else {
      clearCachesAndReload();
    }
  }

  public closeVersion(): void {
    // Dismiss the toast only — the update stays armed and applies seamlessly on the
    // user's next navigation. Dismissing means "not now", not "never".
    this.modalVersion = false;
    this.updateToastPending = false;
    this.showUpdateToast = false;
  }

  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      this.message = payload;
    });
  }

  private updateOnlineStatus(): void {
    this.isOnline = window.navigator.onLine;
    console.info(`isOnline=[${this.isOnline}]`);
  }

  private loadModalPwa(): void {
    if (this.platform.ANDROID) {
      this.modalPwaPlatform = 'ANDROID';
      this.modalPwaPlatform1 = 'ANDROID';

      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        this.modalPwaEvent = event;
      });
    }
    if (this.platform.IOS && this.platform.isBrowser) {
      const isInStandaloneMode = ('standalone' in window.navigator) && ((<any>window.navigator)['standalone']);
      if (!isInStandaloneMode) {
        this.modalPwaPlatform = 'IOS';
        this.modalPwaPlatform1 = 'IOS';
      }
    }
  }

  public addToHomeScreen(): void {
    this.modalPwaEvent.prompt();
    this.modalPwaPlatform = undefined;
  }

  public closePwa(): void {
    this.modalPwaPlatform = undefined;
  }

  public closePwa1(): void {
    this.modalPwaPlatform1 = undefined;
  }

  async checkForAppstore() {
    const info = await Device.getInfo();
    if (this.platform.IOS && info.model === 'iPhone' && info.platform === 'web') {
      window.location.href = 'https://apps.apple.com/in/app/picaggo/id1527686260';
    }
  }

  async checkForPlaystore() {
    const info = await Device.getInfo();
    if (this.platform.ANDROID && info.platform === 'web') {
      window.location.href = 'https://play.google.com/store/apps/details?id=application.share.photo.picaggo';
    }
  }
}
